import React, { Component } from 'react';

export default class FormCode extends Component {

  render() {
    return <div className="panel panel-default">
      <div className="panel-body">
        <code>
          &lt;div class=&quot;acerill-custom-form&quot; data-form-id=&quot;{this.props.form.id}&quot;&gt;&lt;/div&gt;<br />
          &lt;script type=&quot;text/javascript&quot; src=&quot;https://custom-forms-client.acerill.com/js/custom-forms-v2.js&quot;&gt;&lt;/script&gt;
        </code>
      </div>
    </div>
  }

}
